module.exports = __webpack_public_path__ + "img/sensor-fire.a598ba6d.svg";